// extracted by mini-css-extract-plugin
module.exports = {"reviewRowComponent":"star-component_reviewRowComponent__FHrj_"};